import { ConfirmationModal, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export enum ScoreCardsEditPageStep {
  details = "details",
  questions = "questions",
}

export const useScoreCardEditPage = () => {
  const { openModal } = useModals();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const confirmExit = () => {
    openModal(ConfirmationModal, {
      question: t("common:unsaved_changes_may_be_lost_title"),
      text: t("common:unsaved_changes_may_be_lost_description"),
      acceptTitle: t("common:leave"),
      secondButtonTitle: t("common:stay"),
      onAccept: async function () {
        navigate("/recruitment/scorecards");
      },
    });
  };

  const navigateToStep = (id: number, newStep: ScoreCardsEditPageStep) => {
    navigate(`/recruitment/scorecards/${id}/setup/${newStep}`);
  };

  return {
    confirmExit,
    navigateToStep,
  };
};
